import { Input, Empty, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { BsArrowDownUp } from "react-icons/bs";
import { TranslateString } from "Utils/Common";
import { Button } from "react-bootstrap";
import { useIntl } from 'react-intl';

const BankList = (props: any) => {
    const intl = useIntl();

    const onSearch = (event: any) => {
        const { target } = event;
        const value = target.value;
        const { name } = target;

        props.setSearchData({ ...props.searchData, [name]: value });
    };

    return (
        <>
            <div className="d-flex">
                <div className="ms-auto mb-1">
                    <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green mr-1" onClick={() => {
                        props?.setEditValue("")
                        props?.setOpenBN(true)
                        props?.setUpdatebtn(false)
                        props?.setSearchBankNameData({ ...props?.setSearchBankNameData, bank_name: "" })
                    }
                        }>{TranslateString('add_bank')}</Button>

                    <Button type="submit" className="btn btn-sm btn-light px-3 cu-btn-green" onClick={() => {
                        props?.setEditId("")
                        props?.setEditValue("")
                        props?.setOpen(true)
                    }
                        }>{TranslateString('add_bank_contact_details')}</Button>
                </div>
            </div>
            <div className='cu-table-border'>
                <table className="table table-sm table-bordered table-striped text-left m-0">
                    <thead>
                        <tr className="align-middle cu-text-small">
                            <td className="cu-bg-green fw-bold">{TranslateString('bank_name')}</td>
                            <td className="cu-bg-green fw-bold text-right">{TranslateString('city_id')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('city_name')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('contact_name')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('email_contact')}</td>
                            <td className="cu-bg-green fw-bold text-right">{TranslateString('phone_number')}</td>
                            <td className="cu-bg-green fw-bold text-center">{TranslateString('actions')}</td>
                        </tr>
                        <tr className="align-middle">
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "bank_name" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} onChange={onSearch} name="bank_name" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} name="city_id" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "city_name" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} name="city_name" /></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} name="bank_contact_name" /></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} name="bank_contact_email" /></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} name="bank_contact_phone" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}></td>
                        </tr>
                    </thead>
                    <tbody className="cu-text-small">
                        {props?.bankData?.length > 0 ? props?.bankData?.map((val: any) => {
                            return (
                                <tr key={Math.random()} >
                                    <td className="fw-bold">{val?.BANK_DETAIL?.bank_name}</td>
                                    <td className="text-right fw-bold">{val?.city_id}</td>
                                    <td>{val?.city_name}</td>
                                    <td>{val?.bank_contact_name}</td>
                                    <td>{val?.bank_contact_email}</td>
                                    <td className="text-right">{val?.bank_contact_phone}</td>
                                    <td className="text-center" role='button'>
                                        <div className="d-flex justify-content-center">
                                            <div>
                                                <Tooltip title= {intl.formatMessage({ id: 'delete' })}>
                                                    <DeleteOutlined
                                                        onClick={() => { 
                                                            props.setModalState("delete")
                                                            props.setModalValue(val)
                                                            props.setOpenPop(true)
                                                         }}
                                                        className="m-0 cu-font-bold cu-font-cancel"
                                                    />
                                                </Tooltip>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div>
                                                <Tooltip title= {intl.formatMessage({ id: 'edit' })}>
                                                    <EditOutlined
                                                        className="fs-5"
                                                        onClick={() => { 
                                                            props.setModalState("")
                                                            props.onEditUser(val)
                                                         }}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }) : <tr><td colSpan={9}><Empty description={TranslateString('Empty')} /></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default BankList;